import React from 'react';
import cn from 'classnames';
import { IInputTag } from '@creditflowresearch/uilib/Input/InputTags';
import IconCancel from '@creditflowresearch/uilib/Icon/IconCancel';
import styles from './tagsList.module.scss';

interface IProps {
  dataTest: string,
  tags: IInputTag[],
  isDisabled: boolean,
  onRemoveTag: (index: number) => void,
}

const TagsList = ({
  dataTest,
  tags,
  isDisabled,
  onRemoveTag,
}: IProps) => tags.map(({ value, isValid, customIcon: CustomIcon }, index) => {
  return (
    <span
      data-test={ `${ dataTest }TagWrapper` }
      key={ value }
      className={ cn(styles.tagWrapper, {
        [styles.isNotValid]: !isValid,
      }) }
    >
      { CustomIcon && (<CustomIcon />) }
      { value }
      { !isDisabled && (
        <span
          data-test={ `${ dataTest }RemoveTagIcon` }
          className={ styles.removeTagIconWrapper }
          onClick={ () => onRemoveTag(index) }
        >
          <IconCancel className={ styles.removeTagIcon } />
        </span>
      ) }
    </span>
  );
});

export default React.memo(TagsList);
